import { defineComponent as C, ref as s, computed as c, watch as m, onMounted as T, nextTick as _, onBeforeUnmount as z } from "vue";
import { throttle as b } from "lodash-es";
import y from "./td-longtail-vue-components18.js";
import H from "./td-longtail-vue-components4.js";
import L from "./td-longtail-vue-components3.js";
const U = /* @__PURE__ */ C({
  __name: "image-gallery-2023",
  props: {
    images: { default: void 0 },
    initialSelectedIndex: { default: 0 },
    noZoom: { type: Boolean },
    thumbnailLabel: { default: "Bilder auswählen" },
    textZoom: { default: "Vergrößern" },
    textSelectImage: { default: "Bild Anzeigen" },
    textControlGroup: { default: "Bilder Navigation" },
    textPrevControl: { default: "Vorheriges Bild" },
    textNextControl: { default: "Nächstes Bild" },
    preload: { type: Boolean },
    sizes: { default: void 0 }
  },
  emits: ["zoom", "selected-image"],
  setup(x, { expose: B, emit: i }) {
    const o = x, t = s(o.initialSelectedIndex), d = s(!1), v = s(!1), e = s(null), n = c(() => o.images?.length || 0), u = c(() => n.value > 1), r = c(
      () => o.images?.[t.value]
    ), a = (l) => {
      if (l >= n.value) {
        t.value = 0;
        return;
      }
      if (l < 0) {
        t.value = n.value - 1;
        return;
      }
      t.value = l;
    }, f = () => {
      a(t.value + 1);
    }, g = () => {
      a(t.value - 1);
    }, p = () => {
      o.noZoom || i("zoom", {
        zoomParams: o.textZoom.toLowerCase(),
        selectedImageIndex: t.value,
        selectedImage: r.value
      });
    }, h = () => {
      if (!e.value) return;
      const l = Math.abs(
        e.value.scrollHeight - e.value.scrollTop - e.value.clientHeight
      ) < 3;
      d.value = e.value.scrollTop !== 0, v.value = !l;
    }, I = b(h, 200), S = () => {
      e.value && (e.value.scrollTop -= e.value.clientHeight);
    }, w = () => {
      e.value && (e.value.scrollTop += e.value.clientHeight);
    };
    return m(
      () => o.initialSelectedIndex,
      (l) => {
        a(l);
      }
    ), m(
      () => o.images,
      () => {
        t.value = 0, a(0);
      }
    ), m(r, (l) => {
      l && i("selected-image", l);
    }), T(() => {
      u.value && _(() => {
        setTimeout(() => {
        }, 500);
      });
    }), z(() => {
      e.value?.addEventListener("scroll", I);
    }), B({
      incrementSelectedImageIndex: f,
      decrementSelectedImageIndex: g,
      selectedImageIndex: t,
      selectedImage: r,
      selectImage: a,
      imageCount: n,
      hasMultipleImages: u,
      emitClick: p
    }), { __sfc: !0, props: o, emit: i, selectedImageIndex: t, showScrollUpButton: d, showScrollDownButton: v, thumbnailsContainerElement: e, imageCount: n, hasMultipleImages: u, selectedImage: r, selectImage: a, incrementSelectedImageIndex: f, decrementSelectedImageIndex: g, emitClick: p, handleScroll: h, onScroll: I, scrollUp: S, scrollDown: w, GoliathImageElement: y, Arrow: H, LinkButton: L };
  }
});
export {
  U as default
};
